/** @file Channel descriptor table: where each scalar or flag timeline kind lands in Sample.values. */
import { POSE_LAYOUT as L } from '../../contracts/pose';
import type { NumericBoneChannel } from '../../skeletonData';

/** Timeline kinds handled by the generic channel sampler (one number per key). */
export type ChannelKind = NumericBoneChannel | 'alpha' | 'ikMix' | 'ikSoftness' | 'ikBend' | 'ikStretch' | 'ikCompress';

/** How a key value becomes the sampled local value: setup + v, setup × v, or v as is. */
export type ChannelRelation = 'add' | 'mul' | 'abs';

/** Offset inside the entity's channel block plus the setup relation. */
export interface ChannelDescriptor {
  offset: number;
  rel: ChannelRelation;
}

/** One descriptor per channel kind; bone channels are setup-relative (§5.2), slot and IK channels absolute. */
export const timelineChannels: Readonly<Record<ChannelKind, ChannelDescriptor>> = {
  x: { offset: L.X, rel: 'add' },
  y: { offset: L.Y, rel: 'add' },
  rotation: { offset: L.ROTATION, rel: 'add' },
  scaleX: { offset: L.SCALE_X, rel: 'mul' },
  scaleY: { offset: L.SCALE_Y, rel: 'mul' },
  shearX: { offset: L.SHEAR_X, rel: 'add' },
  shearY: { offset: L.SHEAR_Y, rel: 'add' },
  alpha: { offset: L.SLOT_ALPHA, rel: 'abs' },
  ikMix: { offset: L.IK_MIX, rel: 'abs' },
  ikSoftness: { offset: L.IK_SOFTNESS, rel: 'abs' },
  ikBend: { offset: L.IK_BEND, rel: 'abs' },
  ikStretch: { offset: L.IK_STRETCH, rel: 'abs' },
  ikCompress: { offset: L.IK_COMPRESS, rel: 'abs' },
};
